import React from "react"
import { Box, Grid, Paper, Typography, useTheme, useMediaQuery } from "@material-ui/core"
import useStyles from "../hooks/useStyles"
import { Strings } from "../assets/res/en"
const Unauthorized = () => {
    const classes = useStyles()
    const theme= useTheme()
    const direction = useMediaQuery(theme.breakpoints.up('sm')) === true ? "row" : "column"
    return (
        <Grid className={classes.fullHeight} container direction={direction} justify="center" alignItems="center">
            <Box>
                <Paper elevation={0} className={classes.unAuthorizedPaper}>
                    <Grid container spacing={4} alignItems="center" justify="space-evenly">
                        <Grid item xs={12} sm={4}>
                            <img src='../img/denied.png' alt={Strings.ACCESS_DENIED} />
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <Typography variant="h4">{Strings.ACCESS_DENIED}</Typography>
                            <Box m={2} />
                            <Typography variant="body2" component="p">{Strings.ACCESS_DENIED_DESC}</Typography>
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </Grid>
    )
}
export default Unauthorized